import {
  IconInfrastructureBike16,
  IconInfrastructureScooter16,
  IconMapCar16,
  IconMapNoCar16,
  IconProductCompetitor16,
  IconInfrastructureParking16,
  IconInfrastructurePolice16,
  IconMapWalk16,
} from '@cian/ui-kit-design-tokens/icons';
import React from 'react';
import { IMapRowsProps } from 'shared/mf-infrastructure/components/MapRows';
import { EInsideTAInfrastructureType, ITAInfrastructure } from 'shared/mf-infrastructure/types/transportAccessibility';
import { getAvailableInsideInfrastructureTypes } from 'shared/mf-infrastructure/utils/getAvailableInsideInfrastructureTypes';

const INFRASTRUCTURE_TYPE_TO_ROW_MAP: Record<
  EInsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EInsideTAInfrastructureType.yardWithoutCars]: {
    text: 'Двор без машин',
    IconComponent: IconMapNoCar16,
  },
  [EInsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: IconInfrastructureParking16,
  },
  [EInsideTAInfrastructureType.dropOffPickUpArea]: {
    text: 'Быстрая остановка',
    IconComponent: IconMapCar16,
  },
  [EInsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: IconInfrastructureBike16,
  },
  [EInsideTAInfrastructureType.chargingStations]: {
    text: 'Зарядки электромобилей',
    IconComponent: IconProductCompetitor16,
  },
  [EInsideTAInfrastructureType.scooterParking]: {
    text: 'Парковка самокатов',
    IconComponent: IconInfrastructureScooter16,
  },
  [EInsideTAInfrastructureType.boulevards]: {
    text: 'Пешеходные бульвары',
    IconComponent: IconMapWalk16,
  },
  [EInsideTAInfrastructureType.trafficSafetyElements]: {
    text: 'Безопасность движения',
    IconComponent: IconInfrastructurePolice16,
  },
};

export const getInsideRows = (transportAccessibilityInfrastructure: ITAInfrastructure | undefined) => {
  const { existingInfrastructureTypes, missingInfrastructureTypes } = getAvailableInsideInfrastructureTypes(
    transportAccessibilityInfrastructure,
  );

  const clickableRows: IMapRowsProps['items'] = existingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  const nonClickableRows: IMapRowsProps['items'] = missingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  return {
    clickableRows,
    nonClickableRows,
  };
};
